import { createContext, useContext, useState, useEffect } from "react";
import { translations } from "@/i18n/translations";
import { extras } from "@/i18n/extras";

const LanguageContext = createContext(null);

export const LANGUAGES = [
  { code: "fr", label: "FR" },
  { code: "en", label: "EN" },
  { code: "ru", label: "RU" },
  { code: "ua", label: "UA" },
];

export function LanguageProvider({ children }) {
  const [lang, setLang] = useState(() => localStorage.getItem("ogv_lang") || "fr");

  useEffect(() => {
    localStorage.setItem("ogv_lang", lang);
    document.documentElement.lang = lang;
  }, [lang]);

  const t = (path) => {
    const resolve = (obj) => path.split(".").reduce((o, k) => (o != null ? o[k] : undefined), obj);
    return resolve(translations[lang]) ?? resolve(extras[lang]) ?? resolve(translations.fr) ?? resolve(extras.fr) ?? path;
  };

  return <LanguageContext.Provider value={{ lang, setLang, t }}>{children}</LanguageContext.Provider>;
}

export function useLanguage() {
  return useContext(LanguageContext);
}
